import React, { useState, useRef } from 'react';
import { Box, Typography, IconButton, useMediaQuery, useTheme } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { styled } from "@mui/system";
import { useTranslation } from 'react-i18next';
const partners = [
  { name: 'Partner 1', img: '/image/p1.png' },
  { name: 'Partner 2', img: '/image/p2.png' },
  { name: 'Partner 3', img: '/image/p3.png' },
  { name: 'Partner 4', img: '/image/p4.png' },
  { name: 'Partner 5', img: '/image/p5.png' },
  { name: 'Partner 6', img: '/image/p6.png' },
  { name: 'Partner 7', img: '/image/p7.png' },
  { name: 'Partner 8', img: '/image/p8.png' },
  { name: 'Partner 9', img: '/image/p9.png' },
];

const PartnerSlider = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
  const isMedium = useMediaQuery(theme.breakpoints.down('md'));
 const { t } = useTranslation();
  const startX = useRef(null);
  const isDragging = useRef(false);

  const getImageSize = () => (isSmall ? 80 : isMedium ? 120 : 150);
  const radius = getImageSize() * 2.2;
  const angleStep = 360 / partners.length;

  const handleNext = () => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % partners.length);
  };

  const handlePrev = () => {
    setActiveIndex((prevIndex) => (prevIndex - 1 + partners.length) % partners.length);
  };

  // Mouse events
  const handleMouseDown = (e) => {
    startX.current = e.clientX;
    isDragging.current = true;
  };

  const handleMouseUp = (e) => {
    if (!isDragging.current) return;
    const endX = e.clientX;
    const diff = endX - startX.current;

    if (Math.abs(diff) > 30) {
      diff > 0 ? handlePrev() : handleNext();
    }

    isDragging.current = false;
  };

  const handleMouseLeave = () => {
    isDragging.current = false;
  };

  // Touch events
  const handleTouchStart = (e) => {
    startX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    const endX = e.changedTouches[0].clientX;
    const diff = endX - startX.current;

    if (Math.abs(diff) > 30) {
      diff > 0 ? handlePrev() : handleNext();
    }
  };
const Title3D = styled(Typography)(({ theme }) => ({
  fontWeight: "bold",
  fontSize: "2rem",
  textAlign: "center",
  marginBottom: theme.spacing(4),
  background: "linear-gradient(45deg, dodgerblue, #21CBF3)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  textShadow: "2px 2px 4px rgba(0,0,0,0.4)",
}));
  return (
    <Box
      sx={{
        overflow: 'hidden',
        py: 5,
        backgroundColor: 'lightgray',
        margin:"30px",
        border:"3px solid dodgerblue",
        borderRadius:"30px",
        textAlign: 'center',
        position: 'relative',
      }}
    >
       <Typography
                   variant="h3"
                   align="center"
                   gutterBottom
                   sx={{
                     fontWeight: 800,
                     color: "#007BFF",
                     mb: 4,
                     fontSize: { xs: "1.5rem", sm: "1.5rem", md: "2rem" },
                     fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                     display: "flex",
                     justifyContent: "center",
                     alignItems: "center",
           
                     opacity: 0,
                     transform: "translateY(30px)",
           
                     animation: "fadeSlideUp 1.2s ease-out forwards, pulseGlow 3s ease-in-out infinite",
           
                     textShadow: "2px 2px 6px rgba(0, 123, 255, 0.4)",
           
                     transition: "color 0.3s ease, text-shadow 0.3s ease",
           
                     "&:hover": {
                       color: "#0056b3",
                       textShadow: "3px 3px 12px rgba(0, 86, 179, 0.9)",
                     },
                   }}
                 >
                     {t('partnerSlider.heading')}
                 </Typography>

      <Box
        sx={{
          position: 'relative',
          width: '100%',
          height: getImageSize() * 3,
          perspective: 1200,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          touchAction: 'pan-y', // prevent scrolling on mobile
        }}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseLeave}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        <Box
          sx={{
            position: 'relative',
            width: getImageSize(),
            height: getImageSize(),
            transformStyle: 'preserve-3d',
            transform: `rotateY(${-activeIndex * angleStep}deg)`,
            transition: 'transform 0.8s ease-in-out',
          }}
        >
          {partners.map((partner, index) => {
            const rotateY = index * angleStep;
            return (
              <Box
                key={partner.name}
                sx={{
                  position: 'absolute',
                  width: getImageSize(),
                  height: getImageSize(),
                  transform: `rotateY(${rotateY}deg) translateZ(${radius}px)`,
                  transition: 'all 0.6s ease',
                }}
              >
                <Box
                  component="img"
                  src={partner.img}
                  alt={partner.name}
                  sx={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    borderRadius: 2,
                    boxShadow: '0 4px 20px rgba(0,0,0,0.35)',
                    backgroundColor: '#fff',
                    p: 1,
                  }}
                />
              </Box>
            );
          })}
        </Box>
      </Box>

      <IconButton
        onClick={handleNext}
        sx={{
          mt: 4,
          backgroundColor: '#1976d2',
          color: 'white',
          '&:hover': {
            backgroundColor: '#1565c0',
          },
        }}
      >
        <ArrowForwardIosIcon />
      </IconButton>
    </Box>
  );
};

export default PartnerSlider;
